import createTheme from '@signal/theme/createTheme'
import light from './light'
/* webpack-strip-block:removed */

export const makeLightTheme = () => createTheme(light)
/* webpack-strip-block:removed */

export default makeLightTheme
